var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 38,
    viewBox: "0 0 34 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.9 18.7809L13.6777 27.0032C11.0123 29.6686 6.6866 29.6686 4.01739 27.0032L3.1402 26.126C0.474752 23.4605 0.474752 19.1348 3.1402 16.4656L16.6105 2.99908C19.2759 0.333639 23.6016 0.333639 26.2708 2.99908L27.148 3.87627C29.4182 6.14642 29.757 9.61376 28.1645 12.2416",
    stroke: "#148D9B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.87549 9.73425L20.413 20.2718",
    stroke: "#148D9B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M24.1102 6.03721C22.4726 4.39954 19.8146 4.39954 18.177 6.03721L17.3901 6.82404",
    stroke: "#148D9B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M31.2552 21.5743C29.1131 23.7164 25.6457 23.7164 23.5036 21.5743C21.3614 19.4322 21.3614 15.9648 23.5036 13.8227C25.6457 11.6805 29.1131 11.6805 31.2552 13.8227C33.3974 15.9648 33.3974 19.4322 31.2552 21.5743Z",
    stroke: "#148D9B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M21.8999 17.6966H32.8629",
    stroke: "#148D9B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M27.312 32.2587C27.7992 29.2708 25.7719 26.4538 22.784 25.9666C19.7961 25.4795 16.9791 27.5067 16.4919 30.4946C16.0048 33.4825 18.032 36.2996 21.0199 36.7867C24.0078 37.2739 26.8249 35.2466 27.312 32.2587Z",
    stroke: "#148D9B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M18.022 27.5001L25.7736 35.2517",
    stroke: "#148D9B",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjects);
export default __webpack_public_path__ + "static/media/OBJECTS.30b07d86a8372c24756fdfa42de54671.svg";
export { ForwardRef as ReactComponent };